import { getArray, get, post, put, removeList } from '../index'

export default {
  list: (params) => getArray('contacts', params),
  get: (source, id, thirdpartyContact) => get(`contacts/${id}`, {
    source,
    thirdpartyContact
  }),
  create: (contact) => post(`contacts`, contact, {
    source: 'personal'
  }),
  update: (source, id, contact) => put(`contacts/${id}`, contact, {
    source
  }),
  remove: (source, array) => removeList(`contacts/{id}`, array, {
    source: source
  })
}
